/* eslint import/prefer-default-export: "off" */
export const MAKE_REQUEST_PENDING = 'MAKE_REQUEST_PENDING'
export const FETCH_STATUS = 'FETCH_STATUS'
